<div class="card  panel-flat mt-3">
  <div class="panel-heading">
    <h6 class="panel-title">10 Most Inactive Unit </h6>
    <small class="text-muted"> Based on Max Number of Times Unit Closed </small>
  </div>

  <div class="table-responsive" style="height: 370px;">
    <table class="table text-nowrap">
      <thead>
      <tr>
        <th style="padding: 0px; padding-left: 10px;" >S No.</th>
        <th style="padding: 0px; padding-left: 10px;">Unit Name</th>
        <th>OCMMS ID</th>
        <th>Closed</th>
      </tr>
      </thead>
      <tbody *ngIf="!industryListLoader &&  industryList.length">
      <tr *ngFor="let industry of industryList let i = index" [attr.data-index]="i">

        <td style="padding: 0px; padding-left: 15px;">
          {{i+1}}
        </td>

        <td style="padding: 0px; padding-left: 10px;">
          <div class="media-body">
            <div title="{{industry.name}}" class="media-heading">
              <a [routerLink]="['/industry']" [queryParams]="{industry_id: industry.id | base64:'encode'}" class="letter-icon-title">
                {{(industry.name.length>17)? (industry.name | slice:0:17)+'...':(industry.name)}}
              </a>
            </div>

            <div title="{{industry.industry_type}}" class="text-muted text-size-small">
              {{(industry.industry_type.length>15)? (industry.industry_type | slice:0:15)+'...':(industry.industry_type)}}
            </div>
          </div>
        </td>
        <td>
          <span title="{{industry.hr_ocmms_id}}" class="text-muted text-size-small">
            {{(industry.hr_ocmms_id && industry.hr_ocmms_id.length>10)? (industry.hr_ocmms_id | slice:0:10)+'...':(industry.hr_ocmms_id)}}
          </span>
        </td>
        <td style="text-align: center; color: red;">
          <h6 class="text-semibold no-margin">{{industry.total}} Times</h6>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!industryListLoader && !industryList.length" >
      <tr>
        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
          <div class="label label-danger" style="margin-top: 50px;">No Unit Found</div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="industryListLoader" >
      <tr>
        <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
          <div style="margin-top: 50px;">
            <img src="/assets/images/load.gif" />
          </div>
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</div>
